var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadmore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5379 15.2006H8.28651C4.5546 15.2006 1.5293 12.1753 1.5293 8.44343C1.5293 4.71152 4.5546 1.68622 8.28651 1.68622H17.2951C21.027 1.68622 24.0524 4.71152 24.0524 8.44343C24.0524 12.1753 21.027 15.2006 17.2951 15.2006H15.0427M15.0427 15.2006L18.4213 18.5793M15.0427 15.2006L18.4213 11.822",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadmore);
export default __webpack_public_path__ + "static/media/loadmore.9cff5ab126f68286384a8099d3af23eb.svg";
export { ForwardRef as ReactComponent };